<template>
  <div id="app">
    <Navigation />
    <router-view />
  </div>
</template>

<script>
import Navigation from "./components/Navigation";

export default {
  components: {
    Navigation,
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;700&display=swap");

html {
  background: rgb(30, 144, 255);
  margin: 0;
}
body {
  font-family: "Open Sans", sans-serif;
  font-size: 16px;
  max-width: 100vw;
  margin: 0;
}

#app {
  width: 600px;
  max-width: 100vw;
  margin: 32px auto;
  padding: 0 16px;
  box-sizing: border-box;
}

h1 {
  letter-spacing: -0.02em;
  color: white;
  text-align: center;
  margin: 48px 0;
}

label {
  display: flex;
  color: white;
  margin-bottom: 4px;
}

input[type="text"],
select {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border-radius: 6px;
  min-height: 24px;
  padding: 12px;
  border: none;
  border: 2px solid transparent;
  outline: none;
  font-family: "Open Sans", sans-serif;
  font-size: 16px;
  display: flex;
  margin-bottom: 24px;
  width: 100%;
  box-sizing: border-box;
  appearance: none;
  -webkit-appearance: none;
}

input[type="text"]:active,
input[type="text"]:focus {
  border: 2px solid white;
}

input[type="submit"] {
  background: #0e3f70;
  color: white;
  min-height: 24px;
  padding: 12px;
  width: 100%;
  box-sizing: border-box;
  border: none;
  border-radius: 6px;
  font-family: "Open Sans", sans-serif;
  font-size: 16px;
  outline: none;
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
}
</style>
